export enum UsersFilterTypes {
    Role = 'role'
}
